import React from "react";
import "../styles/home.css";
import { ParticlesBg } from ".";
import Typewriter from "typewriter-effect";
import { pageIds } from "../utils/contants";
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";

export const Home = () => {
  const btnlogo = [
    {
      logo: <FaFacebook />,
      onNav: () => handleClick("https://www.facebook.com/erasgaransari"),
    },
    {
      logo: <FaGithub />,
      onNav: () => handleClick("https://github.com/asgardev119"),
    },
    {
      logo: <FaInstagram />,
      onNav: () => handleClick("https://www.instagram.com/iasgar.ai/"),
    },
    {
      logo: <FaLinkedin />,
      onNav: () => handleClick("https://www.linkedin.com/in/asgar-ansari"),
    },
  ];

  const handleClick = (url) => {
    window.location.href = url;
  };
  return (
    <div className="maincont" id={pageIds.home}>
      <ParticlesBg />
      {/* //hero section img  */}
      <div className="dev"></div>
      <div className="name">
        <h1 id="titleHead">
          <span>
            <Typewriter
              options={{
                strings: [
                  "NodeJs Developer",
                  "Backend Developer",
                  "Frontend Developer",
                  "MERN Stack Developer",
                  "Software Developer",
                ],
                autoStart: true,
                loop: true,
                wrapperClassName: "typewriter-text",
                cursorClassName: "typewriter-cursor",
              }}
            />
          </span>
        </h1>
        <p id="text">
          <b id="p">
            React.js Developer with 1.5 years of hands-on experience building
            responsive, user-friendly web applications. Skilled in React.js,
            JavaScript, HTML5, CSS3, API integration, and modern UI development,
            with additional knowledge of Node.js and REST APIs. Passionate about
            creating seamless user experiences and delivering high-quality web
            applications.
          </b>
        </p>
        <div className="btns">
          {btnlogo.map((obj, index) => {
            return (
              <button key={`${obj.logo}-${index}`} onClick={obj.onNav}>
                {obj.logo}
              </button>
            );
          })}
        </div>
        <a
          href="/pdf/Asgar_Ansari_Software_Developer_Resume.pdf"
          download="Asgar_Ansari_Software_Developer_Resume"
          target="_blank"
          rel="noreferrer"
        >
          <button>Hire me</button>
        </a>
      </div>
    </div>
  );
};
